import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function ResponseCompletePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const reward = location.state?.reward || "0";

  return (
    <div className="max-w-md mx-auto text-center py-12">
      <div className="card">
        <div className="mb-6">
          <svg className="w-20 h-20 text-green-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-100 mb-4">Response Submitted!</h1>

        <p className="text-gray-400 mb-6">
          Thank you for completing this survey. Your responses have been recorded.
        </p>

        {reward !== "0" && (
          <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-4 mb-6">
            <p className="text-green-400 text-lg font-medium">
              You earned {reward} coins!
            </p>
          </div>
        )}

        <div className="space-y-3">
          <Link to="/surveys" className="btn btn-primary block w-full">
            View More Surveys
          </Link>
          <Link to="/wallet" className="btn btn-secondary block w-full">
            Check Your Wallet
          </Link>
        </div>
      </div>
    </div>
  );
}
